/** Ruta de un archivo de frontend/public: torneos123.com lo sirve en la raíz;
 * en cualquier otro host (desarrollo, /tenis/) va bajo /tenis/. */
export function publicAsset(path: string): string {
  const host = window.location.hostname;
  const isTorneosDomain = host === "torneos123.com" || host === "www.torneos123.com";
  return `${isTorneosDomain ? "/" : "/tenis/"}${path}`;
}
